
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import { ITappableArea } from '@/utils/types'
import { IMAGEMAP_MESSAGE } from '@/utils/constants'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:handleAnswerClick'],
})
export default class TappableItem extends Vue {
  @Prop()
  config!: ITappableArea

  @Prop()
  index!: number

  get isClick() {
    if (
      (this.config && this.config.action_type === IMAGEMAP_MESSAGE.ACTION_TYPE.URI && this.config.link_uri !== '') ||
      (this.config && this.config.action_type === IMAGEMAP_MESSAGE.ACTION_TYPE.MESSAGE)
    ) {
      return true
    }
    return false
  }

  handleAnswerClick() {
    if (this.config && this.config.action_type === IMAGEMAP_MESSAGE.ACTION_TYPE.URI && this.config.link_uri !== '') {
      window.open(this.config.link_uri)
    } else {
      this.$emit('update:handleAnswerClick', this.config._id ?? '', this.config.title)
    }
  }
}
